import { useContext, useState } from "react";
import { useSelector } from "react-redux";
import {
  useCreateTerminals,
  useUpdateTerminals,
} from "../../../../hooks/api/mutations/useTerminals";
import { ToastContext } from "../../../../hooks/context";

export const useIntegratedDeviceForm = ({
  terminalDetails,
  terminal_type,
  isEditMode = false,
  closeModal = () => {},
}) => {
  const { storeList } = useSelector((state) => state.profileDetailsReducer);
  const triggerToast = useContext(ToastContext);
  const [formDetails, setFormDetails] = useState({
    merchant_id: terminalDetails?.merchant_id || "",
    terminal_id: terminalDetails?.terminal_id || "",
    terminal_sn: terminalDetails?.terminal_sn || "",
    store_id: terminalDetails?.store?.id || "",
    terminal_type,
    use_on_checkout: terminalDetails?.use_on_checkout || false,
  });

  const { mutate: createTerminalMutate, isLoading: isCreatingTerminal } =
    useCreateTerminals();

  const { mutate: updateTerminalMutate, isLoading: isUpdatingTerminal } =
    useUpdateTerminals(terminalDetails?.id);

  const addTerminal = () => {
    createTerminalMutate(formDetails, {
      onSuccess: () => {
        triggerToast("Terminal creation successful", "success");
        closeModal();
      },
    });
  };

  const updateTerminal = () => {
    updateTerminalMutate(formDetails, {
      onSuccess: () => {
        triggerToast("Terminal update successful", "success");
        closeModal();
      },
    });
  };

  const handleTerminal = () => {
    if (isEditMode) updateTerminal();
    else addTerminal();
  };

  return {
    storeList,
    formDetails,
    isLoading: isCreatingTerminal || isUpdatingTerminal,
    setFormDetails,
    addTerminal,
    updateTerminal,
    handleTerminal,
  };
};
